import { render, staticRenderFns } from "./SearchTypeDropdown.vue?vue&type=template&id=e6a0b09e&"
import script from "./SearchTypeDropdown.vue?vue&type=script&lang=js&"
export * from "./SearchTypeDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports